import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

/* Components */
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Container from './components/layout/Container';
import Message from './components/layout/Message';
import WhatsAppButton from './components/layout/WhatsAppButton';

/* Pages */
import Login from './components/pages/Auth/Login';
import Register from './components/pages/Auth/Register';
import Home from './components/pages/Home';
import Plans from './components/pages/Plans';
import Aviary from './components/pages/Aviary';
import Cage from './components/pages/Cage';
import Bird from './components/pages/Bird';
import BirdProfile from './components/pages/BirdProfile';
import CageProfile from './components/pages/CageProfile';
import Loged from './components/pages/HomeLoged';
import Transaction from './components/pages/Transaction';
import TransactionProfile from './components/pages/TransactionProfile';
import Report from './components/pages/Report';
import BirdReproductionPeriod from './components/pages/BirdReproductionPeriod';
import ReportTree from './components/pages/ReportTree';
import Contact from './components/pages/Contact';
import Feedback from './components/pages/Feedback';
import About from './components/pages/About';

/* Context */
import { UserProvider } from './context/UserContext';

function AppContent() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Considera o criatório/perfil (/aviary) como página de dados caso UserProfile não exista
  const isProfilePage = location.pathname === '/aviary' || location.pathname === '/user/profile';

  return (
    <>
      <Navbar 
        isMobileMenuOpen={isMobileMenuOpen} 
        setIsMobileMenuOpen={setIsMobileMenuOpen} 
      />
      <Message />
      <Container>
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/report/bird-period" element={<BirdReproductionPeriod />} />
          <Route path="/report/genealogy" element={<ReportTree />} />
          <Route path="/report" element={<Report />} />
          <Route path="/transaction/:id" element={<TransactionProfile />} />
          <Route path="/transaction" element={<Transaction />} />
          <Route path="/bird/:id" element={<BirdProfile />} />
          <Route path="/bird" element={<Bird />} />
          <Route path="/cage/:id" element={<CageProfile />} />
          <Route path="/cage" element={<Cage />} />
          <Route path="/aviary" element={<Aviary />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/loged" element={<Loged />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </Container>
      
      <WhatsAppButton 
        forceShow={isProfilePage} 
        isMobileMenuOpen={isMobileMenuOpen} 
      />
      
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <UserProvider>
        <AppContent />
      </UserProvider>
    </Router>
  );
}

export default App;